import apiClient from './apiClient'


const getBudgetCategories = (tenant, seasonId = null) => {
  const params = {
    seasonId
  }
  return apiClient.get(`/${tenant}/BudgetCategory`, { params })
}

const getBudgetCategory = (tenant, id) => {
  return apiClient.get(`/${tenant}/BudgetCategory/${id}`)
}

const createBudgetCategory = (tenant, budgetCategory) => {
  return apiClient.post(`/${tenant}/BudgetCategory`, budgetCategory)
}

const updateBudgetCategory = (tenant, id, budgetCategory) => {
  return apiClient.put(`/${tenant}/BudgetCategory/${id}`, budgetCategory)
}

const deleteBudgetCategory = (tenant, id) => {
  return apiClient.delete(`/${tenant}/BudgetCategory/${id}`)
}

const getRelations = (tenant, id) => {
  return apiClient.get(`/${tenant}/BudgetCategory/${id}/Relations`)
}

export default {
  getBudgetCategories,
  getBudgetCategory,
  createBudgetCategory,
  updateBudgetCategory,
  deleteBudgetCategory,
  getRelations
}
